import React from 'react';
import {Button, Flex, PriorityIcon} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import {homepageStore, HomepageDialog} from '../../store/HomepageStore';
import {openNewGroupDialog, showPortlets} from '../../actions/dialogs';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';
import texts from '../../texts';
import {isGroupUnderLimit} from '../../utils';
import {MAX_GROUPS_COUNT} from '../../constants';
import {DefaultGroupsIDs} from '../../enums';
import {createDataTestId} from '../../../../utils/dataTestId';

export const HomepageButtons = observer(() => {
    const {openDialog, groups} = homepageStore;
    const isReachedLimit = !isGroupUnderLimit(groups);
    const isAddPortletDisabled = groups.has(DefaultGroupsIDs.insights) ? false : isReachedLimit;
    const reachedLimit = texts.group_limit_msg.replace(' X ', ` ${MAX_GROUPS_COUNT} `);

    return (
        <Flex justifyContent="flex-end" style={{gap: 8}} wrap>
            <Button
                style={{display: 'none'}}
                skin="secondary"
                size="medium"
                onClick={() => openDialog(HomepageDialog.copyHomepage, true)}
            >
                Copy
            </Button>

            <ModernTooltip tooltip={texts.add_widgets_tooltip} position="top-end" delay={1000}>
                <Button
                    skin="secondary"
                    size="medium"
                    icon={PriorityIcon.addPortlet}
                    onClick={showPortlets}
                    disabled={isAddPortletDisabled}
                    {...createDataTestId('open-insights-dialog-btn', true)}
                />
            </ModernTooltip>

            <ModernTooltip
                tooltip={isReachedLimit ? reachedLimit : texts.add_group_tooltip}
                position="top-end"
                delay={1000}
            >
                <Button
                    skin="secondary"
                    size="medium"
                    prefixIcon={PriorityIcon.gridView}
                    onClick={openNewGroupDialog}
                    disabled={isReachedLimit}
                    {...createDataTestId('open-group-dialog-btn', true)}
                >
                    {texts.new_group_btn}
                </Button>
            </ModernTooltip>
        </Flex>
    );
});
